export const CREATE_OR_UPDATE_LANGUAGE = 'CREATE_OR_UPDATE_LANGUAGE';
